'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = isValidFunction;

var _InvalidParamError = require('../errors/InvalidParamError');

var _InvalidParamError2 = _interopRequireDefault(_InvalidParamError);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function isValidFunction(fn) {
  if (!fn) {
    return false;
  }

  if (typeof fn !== 'function') {
    throw new _InvalidParamError2.default('method', '', 'must be a function');
  }

  return true;
}